import React, { useState, useEffect, memo } from 'react'
import Link from '../Link'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import ArrowRight from '../../../assets/images/ArrowRight.svg'
import useWindowSize from '../../hooks/useWindowSize'

import {
  valueOuterContainer,
  valueInnerContainer,
  valueColumnContainer,
  valueHeadingContainer,
  valueColumn,
  valueDark,
  valueTextContainer,
  valueImageContainer,
  valueAltDisplay,
  valueNormalImageContainer,
  valueFourColumns,
  ctaLinkArrow,
} from './index.module.css'

import { isSvgOrGif } from '../../utils'

const Value = ({
  title,
  components,
  isDarkTheme,
  hideTitle,
  backgroundColor,
  alternateDisplayMode,
}) => {
  const defaultBackgroundColor = isDarkTheme ? '#3C3C3C' : '#F8F8F8'
  const size = useWindowSize()
  const [isTablet, setIsTablet] = useState(false)
  const LinkWrapper = ({ url, children }) => {
    return url ? <Link to={url}>{children}</Link> : <>{children}</>
  }

  useEffect(() => {
    setIsTablet(size.width <= 834 && size.width >= 510)
  }, [size.width])

  return (
    <div
      className={[
        isDarkTheme ? valueDark : '',
        alternateDisplayMode ? valueAltDisplay : '',
      ].join(' ')}
      style={{
        backgroundColor: backgroundColor
          ? backgroundColor
          : defaultBackgroundColor,
      }}
    >
      <div className={['wrapper', valueOuterContainer].join(' ')}>
        <div className={['container', valueInnerContainer].join(' ')}>
          {(hideTitle === null || hideTitle === false) && (
            <div className={valueHeadingContainer}>
              <h2>{title}</h2>
            </div>
          )}
          <div
            className={[
              valueColumnContainer,
              isTablet ? valueFourColumns : '',
            ].join(' ')}
          >
            <div className={valueHeadingContainer}>
              <h2>{title}</h2>
            </div>
            {components &&
              components.map(
                ({ ctaText, ctaUrl, subtitle, title, image }, index) => {
                  return (
                    <div className={valueColumn} key={index}>
                      <div className={valueTextContainer}>
                        {image &&
                          (isSvgOrGif(image.file.url) ? (
                            <div
                              className={[
                                valueImageContainer,
                                valueNormalImageContainer,
                              ].join(' ')}
                            >
                              <Link to={ctaUrl}>
                                <img
                                  src={image.file.url}
                                  alt={image.description}
                                  style={{
                                    height:
                                      image.file.details.image.height >
                                      image.file.details.image.width
                                        ? '100%'
                                        : '',
                                  }}
                                />
                              </Link>
                            </div>
                          ) : (
                            <div className={valueImageContainer}>
                              <Link to={ctaUrl}>
                                <GatsbyImage
                                  image={getImage(image.valueIcon)}
                                  alt={image.description}
                                />
                              </Link>
                            </div>
                          ))}
                        {title && (
                          <h3>
                            {<LinkWrapper url={ctaUrl}>{title}</LinkWrapper>}
                          </h3>
                        )}
                        {subtitle && (
                          <p>
                            <LinkWrapper url={ctaUrl}>
                              {subtitle.subtitle}
                            </LinkWrapper>
                          </p>
                        )}
                        {ctaText && ctaUrl && (
                          <Link to={ctaUrl}>
                            {ctaText}
                            <ArrowRight className={ctaLinkArrow} />
                          </Link>
                        )}
                      </div>
                    </div>
                  )
                }
              )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Value
